
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/openings/[slug]",
      function () {
        return require("private-next-pages/learn/openings/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/openings/[slug]"])
      });
    }
  